import {axiosFormData, axiosJSON} from './axiosInstances';

const getHeaders = () => ({
  headers: {
    Authorization: `Token ${localStorage.token}`
  }
});

const getSkip = page => page * 20 - 20;

const getLimit = page => page * 20;

export default {

  login: ({ username, password }) => {
    const credentials = new FormData();
    credentials.append("username", username);
    credentials.append("password", password);
    return axiosFormData.post("/token-auth/", credentials);
  },

  loadFilters: ({reportUrl}) => {
    const body = {
      report_url: reportUrl
    };
    return axiosJSON.post("/get_report_filters/", body, getHeaders())
  },

  loadReportInfo: ({ reportUrl }) => {
    const body = {
      report_url: reportUrl
    };
    return axiosJSON.post("/get_report_info/", body, getHeaders())
  },

  loadTopWords: ({ reportUrl, filters }) => {
    const body = {
      report_url: reportUrl,
      meta_filter: filters
    };
    return axiosJSON.post("/get_top_words/", body, getHeaders())
  },

  loadSentimentBreakdown: ({ reportUrl, filters }) => {
    const body = {
      report_url: reportUrl,
      meta_filter: filters
    };
    return axiosJSON.post("/sentiment_breakdown/", body, getHeaders())
  },

  loadPrimaryEmotionsBreakdown: ({ reportUrl, filters }) => {
    const body = {
      report_url: reportUrl,
      meta_filter: filters
    };
    return axiosJSON.post("/primary_emotions_breakdown/", body, getHeaders())
  },

  loadResponses: ({ reportUrl, filters, page, scoreName }) => {
    const body = {
      report_url: reportUrl,
      meta_filter: filters,
      score_column_name: scoreName,
      limit: getLimit(page),
      skip: getSkip(page)
    };
    return axiosJSON.post("/get_data_rows/", body, getHeaders())
  },

  loadReports: () => {
    return axiosJSON.get("/get_old_reports_list/", getHeaders())
  },

  addReport: ({ reportUrl, name, password }) => {
    const body = {
      report_url: reportUrl,
      name,
      password
    };
    return axiosJSON.post("/move_report_to_hb2/", body, getHeaders())
  },

  loadWordVerbatims: ({ reportUrl, filters, word }) => {
    const body = {
      report_url: reportUrl,
      meta_filter: filters,
      word
    };
    return axiosJSON.post("/get_value_by_word/", body, getHeaders())
  },

  loadHbIndexData: ({ reportUrl, filters, score }) => {
    const body = {
      report_url: reportUrl,
      meta_filter: filters,
      score_column_name: score
    };
    return axiosJSON.post("/hb_index_by_filter/", body, getHeaders())
  },

  getTaxonomyList: () => {
    return axiosJSON.get("/get_taxonomy_list/", getHeaders())
  },

  addWords: ({ taxonomy, terms }) => {
    return axiosJSON.post(
      "/add_new_rows/",
      {
        taxonomy,
        terms
      },
      getHeaders()
    )
  },

  addTaxonomy: ({ id }) => {
    const body = {
      _id: id,
      rows: 0,
      companies: []
    };
    return axiosJSON.post(
      "/add_taxonomy/",
      body,
      getHeaders()
    )
  }
}


// WEBPACK FOOTER //
// ./src/API.js